import { useEffect, useState } from 'react'
import { Parent } from '@/types/Parent'
import { Daycare } from '@/types/Daycare'
import { Child, ChildDaycare } from '@/types/Child'

interface UseParentChildDialogsArgs {
    parent?: Parent
    currentDaycare: Daycare
    isParent: boolean
}

interface UseParentChildDialogsState {
    isNoChildDialogOpen: boolean
    isChildWithoutSectionDialogOpen: boolean
    closeNoChild: () => void
    closeChildWithoutSection: () => void
}

export function useParentChildDialogs({
    parent,
    currentDaycare,
    isParent
}: UseParentChildDialogsArgs): UseParentChildDialogsState {
    const [isNoChildDialogOpen, setNoChildDialogOpen] = useState(false)
    const [isChildWithoutSectionDialogOpen, setChildWithoutSectionDialogOpen] = useState(false)

    useEffect(() => {
        if (!isParent || !parent) {
            setNoChildDialogOpen(false)
            setChildWithoutSectionDialogOpen(false)
            return
        }

        if (parent.childs.length === 0) {
            setNoChildDialogOpen(true)
            return
        }

        const childsVisible: Child[] = parent.childs.filter((child: Child): ChildDaycare | undefined =>
            child.daycares.find((c: ChildDaycare) => c.daycareId === currentDaycare.id && c.visible)
        )

        const childsWithoutSection: Child[] = parent.childs.filter((child: Child): ChildDaycare | undefined =>
            child.daycares.find(
                (c: ChildDaycare) => c.daycareId === currentDaycare.id && c.sections.length === 0 && c.visible
            )
        )

        setChildWithoutSectionDialogOpen(
            childsWithoutSection.length > 0 && childsWithoutSection.length >= childsVisible.length
        )
    }, [parent, currentDaycare, isParent])

    return {
        isNoChildDialogOpen,
        isChildWithoutSectionDialogOpen,
        closeNoChild: () => setNoChildDialogOpen(false),
        closeChildWithoutSection: () => setChildWithoutSectionDialogOpen(false)
    }
}
